import logo1 from "./image/logo1.png";
import logo2 from "./image/logo2.png";
import logo3 from "./image/logo3.png";
import logo4 from "./image/logo4.png";

import dashboard from "./image/dashboard.jpg";
import tempAvatar from "./image/temp-avatar.png";

import hero from "./image/hero/hero.jpg";
import heroBg from "./image/hero/hero-bg.jpg";

import mailcheck from "./image/mailcheck.png";
import instructorRecruitment from "./image/instructor-recruitment.png";

import hero1 from "./image/prouct/hero-1.jpg";
import hero2 from "./image/prouct/hero-2.jpg";
import hero3 from "./image/prouct/hero-3.jpg";
import hero4 from "./image/prouct/hero-4.jpg";
import hero5 from "./image/prouct/hero-5.jpg";

import earphone1_1 from "./image/prouct/earphone1/1.jpg";
import earphone1_2 from "./image/prouct/earphone1/2.jpg";
import earphone1_3 from "./image/prouct/earphone1/3.jpg";
import earphone1_4 from "./image/prouct/earphone1/4.jpg";

import earphone2_1 from "./image/prouct/earphone2/1.jpg";
import earphone2_2 from "./image/prouct/earphone2/2.jpg";
import earphone2_3 from "./image/prouct/earphone2/3.jpg";
import earphone2_4 from "./image/prouct/earphone2/4.jpg";

export const logoImg1 = logo1;
export const logoImg2 = logo2;
export const logoImg3 = logo3;
export const logoImg4 = logo4;

export const dashboardImg = dashboard;
export const tempAvatarImg = tempAvatar;
export const tempCoverImg = dashboard;

export const heroImg = hero;
export const heroBgImg = heroBg;

export const mailcheckImg = mailcheck;
export const instructorRecruitmentImg = instructorRecruitment;

export const product_hero1Img = hero1;
export const product_hero2Img = hero2;
export const product_hero3Img = hero3;
export const product_hero4Img = hero4;
export const product_hero5Img = hero5;

export const product_earphone1_1Img = earphone1_1;
export const product_earphone1_2Img = earphone1_2;
export const product_earphone1_3Img = earphone1_3;
export const product_earphone1_4Img = earphone1_4;

export const product_earphone2_1Img = earphone2_1;
export const product_earphone2_2Img = earphone2_2;
export const product_earphone2_3Img = earphone2_3;
export const product_earphone2_4Img = earphone2_4;

